/**
 * Created by Victor Rojo on 28/5/19.
 */
import {Component, Input, OnDestroy, ViewChild, ElementRef} from '@angular/core';

import * as Highcharts from 'highcharts/highstock';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exporting_data from 'highcharts/modules/export-data';
import HC_xrange from 'highcharts/modules/xrange';

import { WidgetService }            from "../../widget/Widget.service";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {SSEElement} from "../../element/Element";
import {ChartWidget, ChartSerie, ChartTypes, ChartTimeGroups} from "../../widget/Widget";
import {WidgetTypes} from "../../widget/Widget";
import {I18NService} from "../../../shared/i18n/i18n.service";

HC_exporting(Highcharts);
HC_exporting_data(Highcharts);
HC_xrange(Highcharts);

@Component({
  selector: 'chart',
  templateUrl: './Chart.component.html',
  styleUrls: ['./Chart.component.css']
})
export class ChartComponent extends WidgetStatusChangeAware{

  subscriptions: any[] = [];
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {  };
  dateRangeFilter:any;
  series: any[];
  interval: string = null;
  groupFunction: string = null;
  hasLive = true;

  isLive = false;
  chart: Highcharts.Chart;
  chartCallback: Highcharts.ChartCallbackFunction;
  @ViewChild('chart', { static: true }) chartElement: ElementRef;
  colors = [ "#0d3f85", "#b744d3", "#dd5e46", "#feb90c", "#96bd1e","#634d38", "#0080cd", "#025c37", "#ef9027", "#04afa0"];

  chartTimeGroup;

  constructor(
              private i18nService: I18NService,
              private widgetService: WidgetService,
              private iPlaceDataChangeService1: IPlaceDataChangeService) {
    super(iPlaceDataChangeService1);

    let startDate = new Date();
    let endDate = new Date();
    startDate.setHours(0,0,0,0);
    startDate.setTime(startDate.getTime() - (7 * 86400000) );
    this.dateRangeFilter = [startDate, endDate];
    var self = this;
    this.chartCallback = chart => { self.chart = chart; };

    this.subscriptions.push(this.iPlaceDataChangeService1.elementChange$.subscribe( (element:SSEElement) => {
      if ( this.chart && this.isLive ) {
        this.chart.series
          .filter( s => s.options["elementId"] == element.id)
          .forEach( s => {
            if ( this.widget.chartType == ChartTypes.BINARY  ) {
              let serie = this.series.filter( s => s.elementId == element.id)[0];
              serie.data.push([element.updateDate, Number(element.value)]);
              let series = this.parseBinarySeries([serie]);
              s.setData(series[0].data, false);
            } else if ( this.widget.chartType == ChartTypes.DONUT  ) {
              let serie = this.series.filter( s => s.elementId == element.id)[0];
              serie.data.push([element.updateDate, Number(element.value)]);
              let series = this.parseDonutSeries([serie]);
              s.setData(series[0].data, false);
            } else {
              s.addPoint([element.updateDate, Number(element.value)]);
            }
          });
        let endDate = this.dateRangeFilter[1];
        if ( endDate.getTime() < element.updateDate ) {
          this.dateRangeFilter[1].setTime(element.updateDate);
        }
        let range = this.chart.xAxis[0]["oldMax"] - this.chart.xAxis[0]["oldMin"];
        this.chart.xAxis[0].setExtremes(endDate.getTime() - range,endDate.getTime());
      }
    }));

  }

  get widget(): ChartWidget {
    return this._widget as ChartWidget;
  }

  @Input()
  set widget(chartWidget: ChartWidget) {
    this._widget = chartWidget;
    this.updateValues(chartWidget);
  }

  private updateValues(chartWidget: ChartWidget){
    this.series = chartWidget.series;
    this.fillWithPrevious(this.series);
    if ( chartWidget.chartType == ChartTypes.LINE ) {
      this.chartConstructor = "stockChart";
      this.interval = "5m";
      this.groupFunction = "last";
      this.chartOptions = this.getLineChartConfig(chartWidget);
    } else if ( chartWidget.chartType == ChartTypes.BAR  ) {
      this.chartConstructor = "stockChart";
      this.chartOptions = this.getBarChartConfig(chartWidget);
    } else if ( chartWidget.chartType == ChartTypes.BINARY  ) {
      this.chartConstructor = "stockChart";
      this.chartOptions = this.getBinaryChartConfig(chartWidget);
    } else if ( chartWidget.chartType == ChartTypes.DONUT  ) {
      this.chartConstructor = "chart";
      this.hasLive = false;
      this.chartOptions = this.getDonutChartConfig(chartWidget);
    }
  }

  private getLineChartConfig(chartWidget: ChartWidget):Highcharts.Options{
    this.series.forEach(serie => {
      serie.showInNavigator=true;
    });
    let chartOptions = this.getBaseChartConfig();
    chartOptions.chart.type = "line";
    chartOptions.series = this.series;
    //chartOptions.plotOptions = {
    //  series: {
    //    dataGrouping: {
    //      approximation: 'average', // "average", "averages", "open", "high", "low", "close" and "sum"
    //      enabled: true,
    //      forced: true,
    //      units: [[ 'second',  [30] ]]
    //    }
    //  }} as Highcharts.PlotOptions;
    return chartOptions;
  }

  private getBarChartConfig(chartWidget: ChartWidget):Highcharts.Options{
    this.series.forEach(serie => {
      serie.type = 'column';
      serie.showInNavigator=false;
    });
    var units;
    switch( chartWidget.chartTimeGroup ){
      case ChartTimeGroups.HOUR:
        units = [[ 'hour',  [1] ]];
        break;
      case ChartTimeGroups.DAY:
        units = [[ 'day',  [1] ]];
        break;
      case ChartTimeGroups.MONTH:
        units = [[ 'month',  [1] ]];
        break;
    }
    this.chartTimeGroup = chartWidget.chartTimeGroup;
    let chartOptions = this.getBaseChartConfig();
    chartOptions.series = this.series;
    chartOptions.rangeSelector.selected = 4;
    chartOptions.chart.alignTicks = false;
    chartOptions.plotOptions = {
      series: {
          dataGrouping: {
            approximation: 'sum', // "average", "averages", "open", "high", "low", "close" and "sum"
            enabled: true,
            forced: true,
            units: units
        }
      }} as Highcharts.PlotOptions;
    return chartOptions;
  }

  private getBinaryChartConfig(chartWidget: ChartWidget):Highcharts.Options{
    let series = this.parseBinarySeries(chartWidget.series);
    let aux_names = [];
    let chartOptions = this.getBaseChartConfig();
    chartWidget.series.forEach(serie => {
      aux_names.push("");
    });
    chartOptions.chart.type = 'xrange';
    chartOptions.series = series;
    chartOptions.xAxis = {
      type: 'datetime',
      ordinal: false
    };
    chartOptions.yAxis = {
      max:(aux_names.length-1),
      opposite: false,
      categories: aux_names,
      gridLineWidth:0
    };
    chartOptions.tooltip = {
      useHTML: true,
        headerFormat: '',
        pointFormat:
      '<span style="color:{series.color}">\u25CF' +' {series.name}   </span><br/> ' +
      '{point.x:%d-%m-%Y %H:%M:%S }' +
      " - " + '{point.x2:%d-%m-%Y %H:%M:%S }' +
      '  <br/>' + this.i18nService.get("duration") + ': {point.r}   <br/>',
    }
    return chartOptions;
  }

  private getDonutChartConfig(chartWidget: ChartWidget):Highcharts.Options{
    let series = this.parseDonutSeries(chartWidget.series);
    let chartOptions = this.getBaseChartConfig();
    chartOptions.chart.type = "pie";
    chartOptions.title = {
      text: '&nbsp;',
      useHTML: true
    };
    chartOptions.plotOptions = {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        showInLegend: true,
        minSize: 250,
        dataLabels: {
          enabled: false,
          allowOverlap: false,
          distance: -50,
          format: '{point.name}<br>{point.percentage:.2f} %',
        }
      }
    } as Highcharts.PlotOptions;
    chartOptions.legend = {
      enabled:true,
      useHTML: true,
      labelFormat: "<div class='donut-label'><span class='donut-label-value'>{percentage:.2f} %</span><br><span class='donut-label-name'>{name}</span><br><div class='separator'></div><br></div>",
      //labelFormatter: function () {
      //  return '<span title="' + this.name + '">' + this.name + ' ' + this.percentage.toFixed(2) + '</span>';
      //},
      align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        x: 0,
        y: 40,
      width: 175
    };
    chartOptions.tooltip.pointFormat = "<b>{point.percentage:.2f} %</b><br/>{point.y}";
    chartOptions.series = series;
    return chartOptions;
  }

  private parseBinarySeries(chartSeries:ChartSerie[]):any[]{
    let series = [];

    chartSeries.forEach((serie, index) => {
      let prevDate = this.dateRangeFilter[0].getTime();
      let currentValue;
      let data = [];
      let binarySerie = {
        elementId: serie.elementId,
        name: serie.name,
        pointWidth: 15,
        showInNavigator: false,
        colorByPoint: false,
        data: data
      };
      if ( serie.data ) {
        serie.data.forEach( values => {
          let time = values[0];
          let value = values[1];
          if ( !value && time > prevDate) {
            data.push({
              x: prevDate,
              x2: time,
              r: this.timeDistance(time, prevDate),
              y: index
            });
          }
          prevDate = time;
          currentValue = value;
        });
        if ( currentValue ) {
          let time = new Date().getTime();
          data.push({
            x: prevDate,
            x2: time,
            r: this.timeDistance(time, prevDate),
            y: index
          });
        }
      }
      series.push(binarySerie);
    });
    return series;
  }

  private timeDistance(date1, date2) {
    let distance = Math.abs(date1 - date2);
    const hours = Math.floor(distance / 3600000);
    distance -= hours * 3600000;
    const minutes = Math.floor(distance / 60000);
    distance -= minutes * 60000;
    const seconds = Math.floor(distance / 1000);
    return `${hours}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
  };

  private parseDonutSeries(chartSeries:ChartSerie[]):any[]{
    let data = [];
    let series = [{
      name: "",
      innerSize: '70%',
      showInNavigator: false,
      data: data
    }];

    chartSeries.forEach((serie, index) => {
      let value = 0;
      if ( serie.data ) {
        value = serie.data
          .map( values => values[1])
          .reduce((a,b) => a + b, 0);
        data.push([serie.name, value ? value : 0]);
      }
    });
    return series;
  }

  private getBaseChartConfig():Highcharts.Options{
    var self = this;
    return {
      chart: {
        zoomType: 'x',
      },
      colors: [ "#0d3f85", "#b744d3", "#dd5e46", "#feb90c", "#96bd1e","#634d38", "#0080cd", "#025c37", "#ef9027", "#04afa0"],
      tooltip: {
        valueDecimals: 2,
        shared: true,
        crosshairs: true,
        split: false
      },
      rangeSelector: {
        buttons: [
          {
            type: 'hour',
            count: 12,
            text: '12h'
          },
          {
            type: 'day',
            count: 1,
            text: '1d'
          },
          {
            type: 'day',
            count: 7,
            text: '7d'
          },
          {
            type: 'month',
            count: 1,
            text: '1m'
          },
          {
            type: 'all',
            text: 'Todo'
          },
        ],
        inputEnabled: false,
        selected: 1
      },
      exporting: {
        menuItemDefinitions: {
          // Custom definition
          downloadPNG: {
            onclick: function () {
              var c = document.createElement('canvas');

              let element = self.chartElement["el"].nativeElement;
              c.width = element.clientWidth;
              c.height = element.clientHeight;
              var ctx = c.getContext('2d');

              var svgURL = new XMLSerializer().serializeToString(element.querySelector("svg"));
              var img  = new Image();
              img.onload = function(){
                let self2:any = this;
                ctx.drawImage(self2, 0,0);
                var link = document.createElement('a');
                link.setAttribute('download', self.widget.name + new Date().toLocaleString() + '.png');
                link.setAttribute('href', c.toDataURL("image/png").replace("image/png", "image/octet-stream"));
                link.click();
              };
              img.src = 'data:image/svg+xml; charset=utf8, '+encodeURIComponent(svgURL);
            },
            text: 'Download PNG'
          }
        },
        filename: self.widget.name + new Date().toLocaleString(),
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "separator", "downloadCSV", "downloadXLS"]
          }
        }
      },
      yAxis: [{
        labels: {
          align: 'left'
        },
        resize: {
          enabled: true
        }
      }],
      credits: {
        enabled: false
      },
      legend:{
        enabled:true
      },
    } as Highcharts.Options;
  }

  onClickSearchBtn(dateRange:any){
    if ( this.chart && !this.isLive) {
      this.reloadSeries(dateRange, this.interval, this.groupFunction);
    }
  }

  reloadSeries(dateRange:any, interval, groupFunction){
    let startDate = new Date(dateRange[0].getTime());
    let endDate = new Date(dateRange[1].getTime());

    this.widgetService.getWidgetSeries(this.widget.widgetId, startDate.getTime(), endDate.getTime(), interval, groupFunction)
      .then((chartSeries:ChartSerie[]) => {
        if ( this.chart ) {
          this.fillWithPrevious(chartSeries);
          this.series = chartSeries;
          let series;
          let chartOptions:Highcharts.Options = null;
          if ( this.widget.chartType == ChartTypes.BINARY  ) {
            series = this.parseBinarySeries(chartSeries);
          } else if ( this.widget.chartType == ChartTypes.DONUT  ) {
            series = this.parseDonutSeries(chartSeries);
          } else {
            series = chartSeries;
          }

          if ( this.widget.chartType == ChartTypes.BAR  ) {
            chartOptions = {
              rangeSelector: {
                selected : 4
              }
            };
          }

          let seriesMap = {};
          series.forEach(serie => seriesMap[serie.elementId] = serie.data);

          this.chart.series.forEach(s => {
            s.setData(seriesMap[s.options["elementId"]], false);
          });
          let range = this.chart.xAxis[0]["oldMax"] - this.chart.xAxis[0]["oldMin"];
          this.chart.xAxis[0].setExtremes(endDate.getTime() - range,endDate.getTime());
          this.chart.redraw();
          if ( chartOptions ) {
            this.chart.update(chartOptions);
          }
        }
      });
  }

  private fillWithPrevious(chartSeries:ChartSerie[]){
    chartSeries.forEach(serie => {
      let previous = null;
      if ( serie.data ) {
        serie.data.forEach(data => {
          if ( data[1] != null ) {
            previous = data[1];
          } else {
            data[1] = previous;
          }
        });
      }
    });
  }

  toogleIsLive(){
    this.isLive = !this.isLive;
    if ( this.isLive ) {
      let startDate = new Date();
      let endDate = new Date();
      startDate.setHours(0,0,0,0);
      startDate.setTime(startDate.getTime() - (7 * 86400000) );
      this.dateRangeFilter = [startDate, endDate];
      this.reloadSeries(this.dateRangeFilter, null, null);
    }
  }


  selectBarsGrouping(chartTimeGroup){
    var units;
    switch( chartTimeGroup ) {
      case ChartTimeGroups.HOUR:
        units = [[ 'hour',  [1] ]];
        break;
      case ChartTimeGroups.DAY:
        units = [[ 'day',  [1] ]];
        break;
      case ChartTimeGroups.MONTH:
        units = [[ 'month',  [1] ]];
        break;
      case ChartTimeGroups.YEAR:
        units = [[ 'year',  [1] ]];
        break;
    }
    this.chartTimeGroup = chartTimeGroup;
    let chartOptions:Highcharts.Options = {};
    chartOptions.plotOptions = {
      series: {
        dataGrouping: {
          approximation: 'sum', // "average", "averages", "open", "high", "low", "close" and "sum"
          enabled: true,
          forced: true,
          units: units
        }
      }} as Highcharts.PlotOptions;

    this.chart.update(chartOptions);
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
